<template>
  <div class="store-info">
    <div class="store-wapper flex" v-if="false">
      <div class="store-logo">
        <img :src="storeInfo.logo" />
      </div>
      <div class="store-tables">
        <div class="tables-info flex">
          <div class="label">TABLES / ROOM</div>
          <div class="colons">:</div>
          <div class="text">{{storeInfo.tablesRoom}}</div>
        </div>
        <div class="order-info flex">
          <div class="label">ORDER No.</div>
          <div class="colons">:</div>
          <div class="text">{{storeInfo.orderNo}}</div>
        </div>
      </div>
    </div>
    <van-steps :active="active" class="uppercase">
      <van-step v-for="(item, index) in stepsList" :key="index">{{ item }}</van-step>
    </van-steps>
    <div v-if="active == 2 && orderInfo.eta_time > 0" class="etaOrder">
      <div >Estimated Time Arrival:</div>
      <div style="color: rgb(238, 45, 36);">{{dateEta}}</div>
      <div style="color: rgb(238, 45, 36);">{{fromEta}} - {{toEta}}</div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props:{
    storeInfo:{
      type:Object,
      default:()=>{
        return {
          logo:'https://media.cdnandroid.com/5b/c8/bc/be/33/imagen-chinese-california-truck-fast-food-cooking-game-0thumb.jpg',
          tablesRoom:'ROOM 5',
          orderNo:'123456789',
          orderStatus:1
        }
      }
    },
    orderInfo:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    orderStatus:{
      type:Number,
      default:0
    },
    isAccept:{
      type:Number,
      default:0
    },
    stepsList:{
      type:Array,
      default:() => {
        return ['Add Order', 'Dining', 'Completed']
      }
    }
  },
  data () {
    return {
      active: 1,
      fromEta: 0,
      toEta: 0,
      dateEta: 0
    }
  },
  created () {
    if (this.orderInfo != null){
        if (this.orderInfo.eta_time > 0){
            this.dateEta = moment(this.orderInfo.eta_time * 1000).format('dddd, D MMM YYYY');
            this.fromEta = moment(this.orderInfo.eta_time * 1000).format('HH:mmA');
            let to = moment(this.orderInfo.eta_time * 1000).add(15, 'm')
            this.toEta = to.format('HH:mmA');
        }
        if (this.orderInfo.dining_mode == 2){
            if (this.isAccept != null){
                if (this.orderStatus == 1 && this.isAccept == 0){
                    this.active = 2;
                } else if (this.orderStatus == 3){
                    this.active = 3;
                } else {
                    this.active = this.orderStatus + this.isAccept;
                }
            } else {
                this.active = this.orderStatus;
            }
            console.log('this.active',this.active)
        } else {
            this.active = this.orderStatus;
        }
    } else {
        this.active = this.orderStatus;
    }
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
@import url('../../assets/css/common.less');
.store-info {
  background-color: @fff;
  .store-wapper {
    padding: 8px;
    .store-logo {
      width: 100px;
      margin: 0 8px 0 0;
      img {
        width: 100%;
        max-width: 100px;
        max-height: 80px;
      }
    }
    .store-tables {
      font-size: @size14;
      .label {
        cursor: pointer;
      }
      .colons {
        padding: 0 5px;
      }
      .text {
        color: rgba(0, 0, 0, 0.7);
      }
      .tables-info {
        margin: 5px 0;
      }
      .order-info {
        margin: 5px 0;
      }
    }
  }
  .etaOrder {
    font-size: 12px;
    text-align: center;
    font-weight: bolder;
    padding: 10px;
  }
}
</style>